import {
  GetAllParcelsRequestBuilder,
  GetParcelsCountRequestBuilder,
  CreateParcelsRequestBuilder,
  DeleteParcelBuilder,
  CancelParcelRequestBuilder,
  UpdateParcelsStatusRequestBuilder,
  UpdateParcelsRequestBuilder,
  UpdateParcelOperatorRequestBuilder,
  CreateParcelItemsRequestBuilder,
  GetAllParcelsReportRequestBuilder,
  CreateParcelsOtherTypeRequestBuilder,
  ResolveParcelConflictsStatusRequestBuilder,
  GetParcelInventoryItemsRequestBuilder,
  UpdateMultiParcelStatusRequestBuilder,
  UpdateInventoryItemsRequestBuilder,
  DeleteParcelItemBuilder,CreateGroupingParcelsRequestBuilder, updateGroupeParcelsStatusesRequestBuilder, UpdateDeliveryCostRequestBuilder, UpdateParcelsQCVIPRequestBuilder, UpdateCustomizedOperationRequestBuilder
} from '../parcels/parcels';
import Client from '../client';
import {flattenObject} from '../helpers';
import {GetAllParcelLogsRequestBuilder} from '../parcel-logs/parcel-logs';

const token = localStorage.getItem('token') || '';

class ParcelsRepository {
  getParcels = async (actions: any) => {
    const makeRequest = new GetAllParcelsRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetParcelsCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    const count = await client.execute(makeCountRequest);
    return {response, count};
  };
  getParcelsItems = async (actions: any) => {
    const makeRequest = new GetAllParcelItemsRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetParcelItemsCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    const count = await client.execute(makeCountRequest);
    return {response, count};
  };
  getParcelsCount = async (actions: any) => {
    const makeCountRequest = new GetParcelsCountRequestBuilder()
      .params(flattenObject({...actions, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeCountRequest);
    return response;
  };
  updateParcels = async (actions: any) => {
    const {body, pagination, callback} = actions.payload;
    const makeUpdateRequest = new UpdateParcelsRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateRequest);
    return {pagination, callback, response};
  };
  updateParcelQc = async (actions: any) => {
    const {params, id} = actions.payload;
    const makeUpdateRequest = new UpdateParcelsQCVIPRequestBuilder()
      .id(id)
      .params(params)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateRequest);
    return response;
  }
  updateDeliveryCost = async (actions: any) => {
    const {body,id} = actions.payload;
    const makeUpdateRequest = new UpdateDeliveryCostRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return "callback";
  }
  updateParcelOperator = async (actions: any) => {
    const {body, id, callback} = actions.payload;
    const makeUpdateRequest = new UpdateParcelOperatorRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return callback;
  };
  updateCustomizedOperation = async (actions: any) => {
    const {body, id, callback} = actions.payload;
    const makeUpdateRequest = new UpdateCustomizedOperationRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return callback;
  };
  updateGroupParcelStatuses = async (actions: any) => {
    const {body, id, callback} = actions.payload;
    const makeUpdateRequest = new updateGroupeParcelsStatusesRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateRequest);
    return callback;
  };
  createParcel = async (actions: any) => {
    const {body, pagination, id, callback} = actions.payload;
    const makeRequest = new CreateParcelsRequestBuilder().data(body).build();
    const client = new Client(token);
    await client.execute(makeRequest);
    return {pagination, callback, id};
  };
  createGroupingParcel = async (actions: any) => {
    const {body, pagination, id, callback} = actions.payload;
    console.log(body)
    const makeRequest = new CreateGroupingParcelsRequestBuilder().data(body).build();
    const client = new Client(token);
    await client.execute(makeRequest);
    return {pagination, callback, id};
  };

  createParcelOtherType = async (actions: any) => {
    const {body, pagination, id, callback} = actions.payload;
    const makeRequest = new CreateParcelsOtherTypeRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeRequest);
    return {pagination, callback, id};
  };
  createParcelItems = async (actions: any) => {
    const {body, id, callback} = actions.payload;
    const makeRequest = new CreateParcelItemsRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeRequest);
    return callback;
  };
  updateParcelStatus = async (actions: any) => {
    const {id, body, pagination, callback} = actions.payload;
    const makeUpdateStatusRequest = new UpdateParcelsStatusRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateStatusRequest);
    return callback;
  };
  resolveParcelConflicts = async (actions: any) => {
    const {id, pagination, callback} = actions.payload;
    const makeUpdateStatusRequest =
      new ResolveParcelConflictsStatusRequestBuilder().id(id).build();
    const client = new Client(token);
    await client.execute(makeUpdateStatusRequest);
    return callback;
  };
  getParcelsWithId = async (actions: any) => {
    const makeRequest = new GetAllParcelsRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getRonadParcelsWithId = async (actions: any) => {
    const makeRequest = new GetAllParcelsRequestBuilder()
      .ronadId(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  cancelParcel = async (actions: any) => {
    const {id, body} = actions.payload;
    const makeRequest = new CancelParcelRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  deleteParcel = async (actions: any) => {
    const makeRequest = new DeleteParcelBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  geParcelsWithId = async (actions: any) => {
    const makeRequest = new GetAllParcelsRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getAllParcelsReport = async (actions: any) => {
    const makeParcelsRequest = new GetAllParcelsReportRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'created,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeParcelsRequest);
    return response;
  };
  getParcelInventoryItems = async (actions: any) => {
    const {...actionsPayload} = actions.payload;
    const makeRequest = new GetParcelInventoryItemsRequestBuilder()
      .params(flattenObject({...actionsPayload}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);

    return response;
  };
  getInventoryItemsWithSerial = async (actions: any) => {
    const {...actionsPayload} = actions.payload;
    const makeRequest = new GetParcelInventoryItemsRequestBuilder()
      .params(flattenObject({...actionsPayload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);

    return response;
  };
  getInventoryItemsWithStatus = async (actions: any) => {
    const makeRequest = new GetParcelInventoryItemsRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);

    return response;
  };
  updateMultiInventoryItemsStatus = async (actions: any) => {
    const {body} = actions.payload;
    const makeRequest = new UpdateMultiParcelStatusRequestBuilder()
      .data(body)
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);

    return response;
  };
  updateInventoryItems = async (actions: any) => {
    const {id} = actions.payload;

    const makeUpdateRequest = new UpdateInventoryItemsRequestBuilder()
      .id(id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeUpdateRequest);

    return response;
  };
  deleteParcelItem = async (actions: any) => {
    const {id} = actions.payload;
    const makeRequest = new DeleteParcelItemBuilder().id(id).build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);

    return response;
  };
  getLogs = async (actions: any) => {
    const makeRequest = new GetAllParcelLogsRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);

    return response;
  };
}

export default new ParcelsRepository();
